import { Component, Input } from "@angular/core";
@Component({
  selector: "popup-content",
  template: `
        <div class="modal fade bs-example-modal-lg" id={{name_Id}}>
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body text-center">
                        <div [ngSwitch]="name_Id">
                            <div *ngSwitchCase="'id-1'">
                                <div> content Health Insurance</div>
                            </div>
                            <div *ngSwitchCase="'id-2'">
                                <div> content PA Insurance</div>
                            </div>
                            <div *ngSwitchCase="'id-3'">
                                <div>content Asset Insurance </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <button type="button" class="btn btn-primary" data-dismiss="modal">ADD</button>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class PopupContent {
  @Input("name_Id")
  name_Id: string = "id-1";
}



// WEBPACK FOOTER //
// ./src/app/shared/common/popup-content/popup-content.component.ts